import * as React from "react"
import { primaryColor100} from '../../../sass/vars.scss';

function Edit(props) {
  return (
    <svg width={42} height={42} viewBox="0 0 42 42" fill="none">
      <circle cx={21} cy={21} r={21} fill={props.backgroundFill || 'none'} />
      <path
        d="M13.394 24.542L24.3 13.291a3.142 3.142 0 114.478 4.408L17.563 28.915h-4.169v-4.373z"
        stroke={props.stroke }
        strokeLinecap="round"
      />
      <path stroke={props.stroke } d="M23.144 15.124l4.478 4.479" />
    </svg>
  )
}

export default Edit;
